import { useMyReviews as usePackageMyReviews } from '@chilipiper/admin-email-agent/src/reviewer-queue'

export type { ReviewItem } from '@chilipiper/admin-email-agent/src/reviewer-queue'

// `listMyReviews` (email-agent service ≥ 0.70.0) is tenant+user scoped —
// workspaceId is only an optional server-side filter. Chilical never filters,
// so reviewers see their drafts across every workspace they belong to. The
// shared hook still types workspaceId as required (admin-agents passes one),
// so the undefined cast lives here — and in the `workspaceId` prop of
// `ReviewerQueuePage` — until the package relaxes its signature.
export const NO_WORKSPACE_FILTER = undefined as unknown as string

export const useMyReviews = (tenantId: string) =>
  usePackageMyReviews(tenantId, NO_WORKSPACE_FILTER)
